import { render, staticRenderFns } from "./tab-items.vue?vue&type=template&id=7de08639"
import script from "./tab-items.vue?vue&type=script&lang=js"
export * from "./tab-items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports